import React from "react";
import { Switch, Route, Router } from "react-router-dom";
import history from "../../../Assets/Lib/history";
import List from "./List";
import Add from "./Add";
import NavigationLayout from "../../../Components/NavigationLayout";
import Edit from "./Edit";

const Labels = () => {
  return (
    <Router history={history}>
      <Switch>
        <Route exact path="/admin/events/labels" component={List} />
        <Route path="/admin/events/labels/new" component={Add} />
        <Route path="/admin/events/labels/:id" component={Edit} />
      </Switch>
    </Router>
  );
};
export default Labels;
